export default "__VITE_PUBLIC_ASSET__373c330a__"